import { FunctionComponent } from "react";

import { ClientProvider } from "@components/ClientProvider";
import { ConfigLoader } from "@components/ConfigLoader";
import { HeaderContextProvider } from "@components/HeaderContextProvider/HeaderContextProvider";
import useServiceWorker from "@hooks/useServiceWorker";
import Routes from "@routes/Routes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "@utils/i18n";
import { ThemeProvider } from "styled-components";

import { Fonts } from "@anwb/poncho/design-tokens/theme";

import { ANWBDarkBrandRefresh } from "@topgun/shared-front-end/src/theme/dark-anwb-brand-refresh";
import { CustomFonts } from "@topgun/shared-front-end/src/typography";

import { ApplicationWrapper, GlobalStyle } from "./styles";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 10,
      staleTime: 1000 * 30,
      useErrorBoundary: true,
    },
  },
});

const Application: FunctionComponent = () => {
  useServiceWorker();

  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <ThemeProvider theme={ANWBDarkBrandRefresh} data-testid="application">
        <Fonts />
        <CustomFonts />
        <GlobalStyle />
        <ConfigLoader>
          <ClientProvider>
            <ApplicationWrapper>
              <HeaderContextProvider>
                <Routes />
              </HeaderContextProvider>
            </ApplicationWrapper>
          </ClientProvider>
        </ConfigLoader>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

export default Application;
